import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface SalesOrderChange {
  salesOrderHeaderId: number;
  source: string;
}

@Injectable({
  providedIn: 'root'
})
export class PosStoreService {
  private salesOrderChangesSubject: BehaviorSubject<SalesOrderChange> = new BehaviorSubject<SalesOrderChange>(null);

  constructor() {}


  public notifySalesOrderChanged(change: SalesOrderChange) {
    this.salesOrderChangesSubject.next(change);
  }

  public salesOrderChanges() {
    return this.salesOrderChangesSubject.asObservable();
  }

}
